import { render, staticRenderFns } from "./suggestion-cate-selector.vue?vue&type=template&id=28b6b340&scoped=true"
import script from "./suggestion-cate-selector.vue?vue&type=script&lang=js"
export * from "./suggestion-cate-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b6b340",
  null
  
)

export default component.exports